import styles from "./SubscribePage.module.scss";
import Purchase from "../subscription/purchase";
import ActiveUserSubscription from "../subscription/ActiveSubcriptionUser";
import { useState, useCallback } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import PublicationSelection from "../subscription/PublicationSelection";
import InstitutionTypeSelection from "../subscription/institution/InstitutionTypeSelection";
import Institution from "../subscription/institution/Institution";
import useAuth from "../../hooks/useAuth";
import useSalesforce from "../../hooks/useSalesforce.js";
import LoginFooter from "./LoginFooter";

export default function SubscribePage() {
  const [searchParams] = useSearchParams();
  const { isSalesforceEnabled } = useSalesforce();
  const location = useLocation();
  const recordId = searchParams.get("id");
  const subscribeStep = location.state?.subscribeStep;
  const subscribeSelections = location.state?.subscribeSelections;
  const initialStep = recordId ? 3 : subscribeStep === 3 ? 3 : 1;
  const initialPublicationStep =
    subscribeStep === 3 && subscribeSelections?.purchaseOption === "singleUser" ? 2 : 1;

  const [step, setStep] = useState(initialStep);
  const [publicationStep, setPublicationStep] = useState(initialPublicationStep);
  const navigate = useNavigate();
  const [selections, setSelections] = useState(() => ({
    selectedApps: subscribeSelections?.selectedApps || [],
    purchaseOption:
      subscribeSelections?.purchaseOption || (recordId ? "institution" : "singleUser"),
    institutionType: subscribeSelections?.institutionType || null,
  }));

  const { activeSubscriptions } = useAuth();
  const activeSubs = activeSubscriptions || [];
  const handleProceedToPurchase = (selections) => {
    setSelections((prevSelections) => ({
      ...prevSelections,
      ...selections,
      institutionType:
        selections.purchaseOption === "singleUser" ? null : prevSelections.institutionType,
    }));
    setPublicationStep(selections.purchaseOption === "singleUser" ? 2 : 1);

    // If institution is selected, go to institution type selection
    if (selections.purchaseOption === "institution") {
      setStep(2);
    } else {
      // For single user, skip to purchase
      setStep(3);
    }
  };

  const handleSelectInstitutionType = (institutionType) => {
    setSelections((prevSelections) => ({
      ...prevSelections,
      institutionType,
    }));
    setStep(3);
  };

  const handleInstitutionSubmit = (formData) => {
    // Handle institution form submission
    console.log("Institution form data:", formData);
  };

  const handleInstitutionDataLoaded = useCallback((institutionType) => {
    // Update the institution type when data is loaded from URL
    setSelections((prev) => ({
      ...prev,
      institutionType: institutionType,
    }));
  }, []);

  const handleBack = () => navigate("/");
  const handleBackToSelection = () => {
    setPublicationStep(1);
    setStep(1);
  };
  const handleBackToInstitutionType = () => {
    // If user came via direct link with ID, go back to home
    if (recordId) {
      navigate("/");
      return;
    }

    if (selections.purchaseOption === "institution") {
      setStep(2); // Go back to institution type selection
    } else {
      setPublicationStep(2);
      setStep(1); // Go back to publication selection
    }
  };
  const handleHeaderBack = () => {
    console.log("Header back clicked, current step:", step);
    if (step === 1) {
      handleBack();
      return;
    }

    if (step === 2) {
      handleBackToSelection();
      return;
    }

    handleBackToInstitutionType();
  };

  const isInstitutionForm = step === 3 && selections.purchaseOption === "institution";
  return (
    <div className={`${styles.subscribePage} ${step === 2 ? styles.purchaseLayout : ""}`}>
      <div className={styles.leftPanel}>
        <img
          src="/assets/icons/PoweredByTG.svg"
          alt="Therapeutic Guidelines Logo"
          className={styles.logo}
        />
      </div>

      <div className={`${styles.rightPanel} ${isInstitutionForm ? styles.widePanel : ""}`}>
        <div className={styles.formWrapper}>
          <div className={styles.purchaseContainer}>
            {!recordId && !isInstitutionForm && (
              <div className={styles.backBtn}>
                <button type="button" className={styles.backLink} onClick={handleHeaderBack}>
                  <i className="tg-icons-RightArrow" /> Back
                </button>
              </div>
            )}

            {recordId ? (
              <Institution
                type={selections.institutionType || "new"}
                onBack={handleBackToInstitutionType}
                onSubmit={handleInstitutionSubmit}
                onDataLoaded={handleInstitutionDataLoaded}
              />
            ) : step === 1 ? (
              <>
                <PublicationSelection
                  onProceedToPurchase={handleProceedToPurchase}
                  activeSubs={activeSubs}
                  initialSelectedApps={selections.selectedApps}
                  initialPurchaseOption={selections.purchaseOption}
                  initialStep={publicationStep}
                />
                {activeSubs.length > 0 && !isSalesforceEnabled && (
                  <ActiveUserSubscription subscriptions={activeSubs} />
                )}
              </>
            ) : step === 2 ? (
              <InstitutionTypeSelection
                onSelectInstitutionType={handleSelectInstitutionType}
                onBack={handleBackToSelection}
              />
            ) : step === 3 && selections.purchaseOption === "institution" ? (
              <Institution
                type={selections.institutionType || "new"}
                onBack={handleBackToInstitutionType}
                onSubmit={handleInstitutionSubmit}
                onDataLoaded={handleInstitutionDataLoaded}
              />
            ) : isSalesforceEnabled ? (
              <></>
            ) : (
              <Purchase initialSelections={selections} onBack={handleBackToSelection} />
            )}
          </div>
          <LoginFooter />
        </div>
      </div>
    </div>
  );
}
